var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnscheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_27642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.125 1.125C9.125 0.501562 8.62344 0 8 0C7.37656 0 6.875 0.501562 6.875 1.125V3H5C3.34531 3 2 4.34531 2 6V6.75V9V21C2 22.6547 3.34531 24 5 24H20C21.6547 24 23 22.6547 23 21V9V6.75V6C23 4.34531 21.6547 3 20 3H18.125V1.125C18.125 0.501562 17.6234 0 17 0C16.3766 0 15.875 0.501562 15.875 1.125V3H9.125V1.125ZM4.25 9H20.75V21C20.75 21.4125 20.4125 21.75 20 21.75H5C4.5875 21.75 4.25 21.4125 4.25 21V9ZM14 18.75C14 18.3522 13.842 17.9706 13.5607 17.6893C13.2794 17.408 12.8978 17.25 12.5 17.25C12.1022 17.25 11.7206 17.408 11.4393 17.6893C11.158 17.9706 11 18.3522 11 18.75C11 19.1478 11.158 19.5294 11.4393 19.8107C11.7206 20.092 12.1022 20.25 12.5 20.25C12.8978 20.25 13.2794 20.092 13.5607 19.8107C13.842 19.5294 14 19.1478 14 18.75ZM13.625 11.625C13.625 11.0016 13.1234 10.5 12.5 10.5C11.8766 10.5 11.375 11.0016 11.375 11.625V14.625C11.375 15.2484 11.8766 15.75 12.5 15.75C13.1234 15.75 13.625 15.2484 13.625 14.625V11.625Z",
    fill: "#E97C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_27642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnscheduled);
export default __webpack_public_path__ + "static/media/Unscheduled.ab5d7d324335f11f4d60a76f5c404f11.svg";
export { ForwardRef as ReactComponent };